<template>
  <div>

    <h6> ID: {{order.id}} 
      <span
          class="label label-warning pull-right"
          v-if="order.status=='1'"
        >Deposit Paid</span>
        <span
          class="label label-info pull-right"
          v-else-if="order.status=='0'"
        >Pending</span>
        <span
          class="label label-success pull-right"
          v-else-if="order.status=='2'"
        >Fully Paid</span>
        <span
          class="label label-danger pull-right"
          v-else-if="order.status=='4'"
        >Cancelled</span>
    </h6>
    <h5>Total {{order.boughtProductTotal | priceLabelToSymbol(order.productPriceLabel)}}</h5>
    <h5>Total Discounted {{order.boughtProductTotalDiscounted | priceLabelToSymbol(order.productPriceLabel)}}</h5>
    <div
      v-for="product in order.boughtProducts"
      :key="product.id"
    >

      <!--<div  v-if="product.product.type=='attended'">-->
      <label>Product Type: <small>{{product.product.type}}</small></label><br>
      <label>Product: <small>{{product.product.name}} </small></label>

      

    </div>

    <!--</div>-->

  </div>
</template>
<script>
export default {
  props: ["order"],
  methods: {
    handleEditClick(id) {
      this.$router.push({ path: "/order/edit/" + id });
    },
    handleDeleteClick() {
      this.$emit("on-delete", this.index);
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Customers/CustomerProfile/Order.vue